/**
 * @file use-saved-filters.ts
 * @description Кастомный хук для управления сохраненными фильтрами пользователя в системе фильтрации Task Manager. Предоставляет функциональность загрузки и сохранения фильтров для различных типов данных с интеграцией в централизованную архитектуру filter фичи. Автоматически обрабатывает ошибки API и возвращает пустые массивы в случае неудачи, используя утилиты подготовки данных фильтров перед сохранением.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-09-04
 * @updated 2025-01-16
 * @dependencies ['axios', '@api/actions/user-saved-data', '@features/filter/types', '@features/filter/helper']
 * @related-files ['@api/actions/user-saved-data.ts', '@features/filter/helper.ts', '@features/filter/types.ts']
 */

import { UserSavedDataService } from '@api/actions/user-saved-data';
import { filterComponent } from '@features/filter/types';
import { prepareFiltersToSave } from '@features/filter/helper';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { TBaseObjectDto } from '@src/types';

export const useSavedFilters = (type: string) => {
    const getFilters = async (): Promise<TBaseObjectDto> => {
        const response: AxiosResponse | AxiosError = await UserSavedDataService.get(type, 'filters');

        if (axios.isAxiosError(response)) {
            return [];
        }

        return response.data;
    };

    const saveFilters = async (filters: filterComponent[]): Promise<void> => {
        await UserSavedDataService.create(type, 'filters', prepareFiltersToSave(filters));
    };

    return { getFilters, saveFilters };
};